import { createAction, handleAction } from 'redux-actions'

export const setSidebarVisibility = createAction('SIDEBAR/VISIBILITY/TOGGLE')

export const sidebar = handleAction(
  setSidebarVisibility,
  state => ({ visibility: !state.visibility }),
  { visibility: false }
)



// WEBPACK FOOTER //
// ./src/components/slidingpane/reducer.js